import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
  CardCarousel,
  CarouselItem,
  Section,
  SectionHeader,
} from '@lanl-web/lanl-components';

import alaLogo from '../../assets/images/ala_logo.png';
import arxivLogo from '../../assets/images/arxiv_logo.png';
import bwbLogo from '../../assets/images/better_world_books_logo.png';
import bioMedLogo from '../../assets/images/biomed_logo.png';
import buildingGreenLogo from '../../assets/images/building_green_logo.png';
import CLIRLogo from '../../assets/images/clir_logo.png';
import CNILogo from '../../assets/images/cni_logo.png';
import eLuna from '../../assets/images/eluna_logo.png';
import IIPCLogo from '../../assets/images/iipc_logo.png';
import InternetArchiveLogo from '../../assets/images/internet_archive_logo.png';
import ORCIDLogo from '../../assets/images/orcid_logo.png';
import OSTIGOVLogo from '../../assets/images/OSTIGOV.png';
import SCOAP3Logo from '../../assets/images/scoap3_logo.png';
import SLALogo from '../../assets/images/sla_logo.png';
import SPARCLogo from '../../assets/images/sparc_logo.png';
import UNTLogo from '../../assets/images/unt_logo.png';
import W3CLogo from '../../assets/images/w3c_logo.png';

import './AssociationsSection.scss';

const images = [
  { image: alaLogo, alt: 'ala logo', url: 'https://www.ala.org' },
  {
    image: arxivLogo,
    alt: 'arvix logo',
    url: 'https://confluence.cornell.edu/display/arxivpub',
  },
  {
    image: bwbLogo,
    alt: 'Betterworld Books Logo',
    url: 'https://www.betterworldbooks.com/',
  },
  {
    image: bioMedLogo,
    alt: 'Biomed Central Logo',
    url: 'www.biomedcentral.com/about/',
  },
  {
    image: buildingGreenLogo,
    alt: 'Building Green Logo',
    url: 'https://www.buildinggreen.com/about',
  },
  {
    image: CLIRLogo,
    alt: 'CLIR Logo',
    url: 'https://customer26007fb00.portal.membersuite.com/login.aspx',
  },
  { image: CNILogo, alt: 'CNI Logo', url: 'thttps://www.cni.org/' },
  { image: eLuna, alt: 'ELUNA Logo', url: 'https://el-una.org/' },
  { image: IIPCLogo, alt: 'IIPC logo', url: 'https://netpreserve.org/' },
  {
    image: InternetArchiveLogo,
    alt: 'Internet Archive Logo',
    url: 'https://archive.org/',
  },
  {
    image: ORCIDLogo,
    alt: 'ORCID Logo',
    url: 'https://orcid.org/members/001G000001WBqVuIAL-los-alamos-national-laboratory',
  },
  { image: OSTIGOVLogo, alt: 'OSTIGOV Logo', url: 'https://www.osti.gov/' },
  { image: SCOAP3Logo, alt: 'SCOAP3 Logo', url: 'https://scoap3.org/' },
  { image: SLALogo, alt: 'SLA Logo', url: 'https://www.sla.org/' },
  {
    image: SPARCLogo,
    alt: 'SPARC logo',
    url: 'https://sparcopen.org/coapi/members/',
  },
  { image: UNTLogo, alt: 'UNT logo', url: '#' },
  { image: W3CLogo, alt: 'W3C logo', url: 'https://www.w3.org/' },
];

export const AssociationsSection = ({ className }) => {
  const classes = classNames('associations-section', className);

  return (
    <Section className={classes}>
      <SectionHeader title='Some of Our Associations Include' />
      <CardCarousel length={images.length}>
        {images.map(({ alt, image, url }, index) => (
          <CarouselItem
            key={`lanl-card-carousel-item-${index}`}
            className='lanl-card-carousel-item'
            itemId={index}
            card
          >
            <a href={url} target='_blank' rel='noreferrer'>
              <img
                key={`association-logo-${index}`}
                src={image}
                alt={alt}
                className='association-logo'
              />
            </a>
          </CarouselItem>
        ))}
      </CardCarousel>
    </Section>
  );
};

AssociationsSection.defaultProps = {};

AssociationsSection.propTypes = {
  className: PropTypes.string,
};

export default AssociationsSection;
